import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/device";

const { actions, types } = createActions({
  addDevice: ["device", "onSuccess", "onFailure"],
  updateDevice: ["id", "device", "onSuccess", "onFailure"],
  setLoading: ["loading"],
  fetchDeviceRequest: ["page", "perPage", "onFailure"],
  exportDeviceRequest: ["page", "perPage", "onSuccess", "onFailure"],
  setInitialFetchIsDone: [],
  setDeviceTotalItems: ["totalItems"],
  setDevicePerPage: ["perPage"],
  setDevicePage: ["page"],
  addDevices: ["devices"],
  setDeviceQs: ["qs"],
});

const reducer = createReducer(initialState, {
  [types.ADD_DEVICES]: (state, { payload }) => ({
    ...state,
    devices: [...payload.devices],
  }),
  [types.SET_LOADING]: (state, { payload }) => ({
    ...state,
    loading: payload.loading,
  }),
  [types.SET_INITIAL_FETCH_IS_DONE]: (state) => ({
    ...state,
    initialFetchIsDone: true,
  }),
  [types.SET_DEVICE_TOTAL_ITEMS]: (state, { payload }) => ({
    ...state,
    totalItems: payload.totalItems,
  }),
  [types.SET_DEVICE_PAGE]: (state, { payload }) => ({
    ...state,
    page: payload.page,
  }),
  [types.SET_DEVICE_PER_PAGE]: (state, { payload }) => ({
    ...state,
    perPage: payload.perPage,
  }),
  [types.SET_DEVICE_QS]: (state, { payload }) => ({
    ...state,
    qs: payload.qs,
    page: 0,
  }),
});

export { reducer as default, types, actions };
